import {
  FETCH_DATA,
  POST_DATA,
  POST_DATA_FAILURE,
  UPDATE_DATA,
  UPDATE_DATA_FAILURE,
} from "../types";

const initialState = {};

export default function pageReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_DATA:
      return {
        ...state,
        ...action.payload,
      };

    case POST_DATA:
      return {
        ...state,
        ...action.payload,
      };

    case POST_DATA_FAILURE:
      return {
        ...state,
        ...action.payload,
      };

    case UPDATE_DATA:
      return {
        ...state,
        ...action.payload,
      };

    case UPDATE_DATA_FAILURE:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
}
